import React from 'react'
import { Outlet } from 'react-router-dom'

function MainCompaniesLayout() {
    return (
        <>
            <Outlet />
        </>
    )
}

export default MainCompaniesLayout;
